import {
  faExclamationTriangle,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { useLanguage } from "../../contexts/LanguageContext";
import { useModalScrollLock } from "../../hooks/useModalScrollLock";

import "./ConfirmModal.css";

const ConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  title = "",
  message = "",
  type = "danger",
}) => {
  const { t } = useLanguage();
  // Lock scroll when this modal is open
  useModalScrollLock(isOpen);
  if (!isOpen) return null;

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  const handleCancel = () => {
    onClose();
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="confirm-modal-overlay" onClick={handleBackdropClick}>
      <div className="confirm-modal">
        <div className="confirm-modal-header">
          <div className={`confirm-modal-icon ${type}`}>
            <FontAwesomeIcon icon={faExclamationTriangle} />
          </div>
          <button className="confirm-modal-close" onClick={handleCancel}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>

        <div className="confirm-modal-body">
          <h3 className="confirm-modal-title">{title}</h3>
          <p className="confirm-modal-message">{message}</p>
        </div>

        <div className="confirm-modal-footer">
          <button className="btn btn-outline" onClick={handleCancel}>
            {t("commons.cancel")}
          </button>
          <button
            className={`btn ${
              type === "danger" ? "btn-danger" : "btn-primary"
            }`}
            onClick={handleConfirm}
          >
            {t("commons.confirm")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
